<template id="Cession">
<Modele id="Cession"/>
</template>

<script>
import Modele from '../Modele.vue'
export default {
	components:{Modele},
	name: 'Cession',
	data () {
		return {}
	}
}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/Immatriculation/Cession.vue